import Link from '@tiptap/extension-link';

export const PreserveStyleLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => {
          const style = element.getAttribute('style');
          if (!style) return null;

          const hasButtonStyling = (
            style.includes('background-color') &&
            style.includes('padding') &&
            (style.includes('display: inline-block') || style.includes('display:inline-block'))
          );

          if (hasButtonStyling) {
            return null;
          }

          return style;
        },
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },
});
